import Vue from 'vue';
import Router from 'vue-router';
import Start from '@/components/Start';
import RetentionFlow from '@/components/RetentionFlow';
import RetentionLink from '@/components/RetentionLink';
import RetentionAnalytics from '@/components/RetentionAnalytics';

import Contact from '@/components/Contact';
import Pricing from '@/components/Pricing';
import Demo from '@/components/Demo';
import TryFree from '@/components/TryFree';

import ReduceChurnSaas from '@/components/Industries/ReduceChurnSaas';

import ReduceChurnBankInsurance from '@/components/Industries/ReduceChurnBankInsurance';
import ReduceChurnPhysical from '@/components/Industries/ReduceChurnPhysical';
import ReduceChurnTelecom from '@/components/Industries/ReduceChurnTelecom';


Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    {
      path: '/try-free',
      name: 'TryFree',
      component: TryFree
    },
    {
      path: '/reduce-churn-saas',
      name: 'SaaS Subscriptions',
      component: ReduceChurnSaas
    },
    {
      path: '/reduce-churn-bank-insurance',
      name: 'Bank & Insurance',
      component: ReduceChurnBankInsurance
    },
    {
      path: '/reduce-churn-physical-products',
      name: 'Physical subscription products',
      component: ReduceChurnPhysical
    },
    {
      path: '/reduce-churn-telecom',
      name: 'Telecom & Mobile',
      component: ReduceChurnTelecom
    },
    {
      path: '/retention-link',
      name: 'Retention Link',
      component: RetentionLink
    },
    {
      path: '/retention-analytics',
      name: 'Retention Analytics',
      component: RetentionAnalytics
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    }
  ]
});
